import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from './main/main.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {BlocksComponent} from './blocks/blocks.component';
import {ProfileQuizComponent} from './profile-quiz/profile-quiz.component';
import {QuizComponent} from './quiz/quiz.component';
import {MainGuard} from './main.guard';
import {ProfileComponent} from './profile/profile.component';
import {ProfileAboutComponent} from './profile/profile-about/profile-about.component';
import {LoginComponent} from './login/login.component';
import {AuthGuard} from '../auth/_guards/auth.guard';

const routes: Routes = [
  {
    path: '', component: MainComponent, children: [
      {path: 'login', component: LoginComponent},
      {path: 'dashboard', component: DashboardComponent},
      {path: 'blocks', component: BlocksComponent, canActivate: [AuthGuard]},
      {path: 'profile-quiz', component: ProfileQuizComponent, canActivate: [AuthGuard]},
      {path: 'chat/:id', component: QuizComponent, canActivate: [AuthGuard]},
      {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
      {path: 'about', component: ProfileAboutComponent, canActivate: [AuthGuard]},
      {path: '**', redirectTo: 'dashboard', pathMatch: 'full'}
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule {
}
